<script>
    import TablaFundas from "./FundasTabla.svelte";
    var fundas = false;
    function mostrarDiv(id){
            fundas = !fundas;
    }
</script>

<div class="row">
    <div class="col-12 col-lg-7 linea">
    </div>
    <div class="col-12 col-lg-5">
        <h2>Fundas Aluminizadas</h2>
    </div>
</div>
<div class="row">
    <div class="col-12 col-lg-4" style="text-align: center;">
        <img src="img/Low/fundas.png" width="75%" alt="Fundas termicas ICEMAGELES">
    </div>
    <div class="col-12 col-lg-8">
            <ul>
                <li>
                    Protege los productos perecibles de la exposición a la radiación solar en los pre-embarques de carga aérea
                </li>
                <li>
                    Reduce el costo y mejora el aprovechamiento de los elementos refrigerantes de la carga
                </li>
                <li>
                    Por su estructura flexible permite su acopio y traslado plegado ocupando un mínimo espacio
                </li>
                <li>
                    Por su sistema de pre-armado, el mismo se realiza en una sola y simple operación
                </li>
            </ul>
    </div>
    <div class="col-12" style="text-align:center;">
        <button class="boton-info" on:click={() => mostrarDiv("fundas")}>+Info</button>
      </div>
</div>
{#if fundas}
  <TablaFundas />
{/if}